/*
 * VULCAN
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/tenantSettingsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a TenantSettings. */
var TenantSettings = /** @class */ (function () {
    /**
     * Create a TenantSettings.
     * @param {SecurityContext} client Reference to the service client.
     */
    function TenantSettings(client) {
        this.client = client;
    }
    TenantSettings.prototype.getAllSettings = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getAllSettingsOperationSpec, callback);
    };
    TenantSettings.prototype.createSetting = function (request, options, callback) {
        return this.client.sendOperationRequest({
            request: request,
            options: options
        }, createSettingOperationSpec, callback);
    };
    TenantSettings.prototype.getSetting = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, getSettingOperationSpec, callback);
    };
    TenantSettings.prototype.updateSetting = function (id, request, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            request: request,
            options: options
        }, updateSettingOperationSpec, callback);
    };
    TenantSettings.prototype.deleteSetting = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, deleteSettingOperationSpec, callback);
    };
    TenantSettings.prototype.getSettings = function (tenantName, options, callback) {
        return this.client.sendOperationRequest({
            tenantName: tenantName,
            options: options
        }, getSettingsOperationSpec, callback);
    };
    return TenantSettings;
}());
export { TenantSettings };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getAllSettingsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/tenants/settings",
    queryParameters: [
        Parameters.scope
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "TenantSettingResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var createSettingOperationSpec = {
    httpMethod: "POST",
    path: "api/v10/tenants/settings",
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateOrUpdateTenantSettingRequest), { required: true })
    },
    responses: {
        201: {
            bodyMapper: Mappers.TenantSettingResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getSettingOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/tenants/settings/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        200: {
            bodyMapper: Mappers.TenantSettingResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var updateSettingOperationSpec = {
    httpMethod: "PUT",
    path: "api/v10/tenants/settings/{id}",
    urlParameters: [
        Parameters.id
    ],
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateOrUpdateTenantSettingRequest), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.TenantSettingResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var deleteSettingOperationSpec = {
    httpMethod: "DELETE",
    path: "api/v10/tenants/settings/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getSettingsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/tenants/settings/{tenantName}",
    urlParameters: [
        Parameters.tenantName
    ],
    queryParameters: [
        Parameters.scope
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "TenantSettingResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=tenantSettings.js.map